import { ADD_UPCOMING_STYLES_QUICK_VIEW_DATA, SET_API_STATUS, SET_LAUNCH_CALENDAR_UPCOMING_STYLES } from 'constants/reduxActions';
import { LaunchCalendarUpcomingStyles, UpcomingStylesQuickViewData } from 'types/launchCalendar';
import { LaunchCalendarUpcomingProductsAction } from 'actions/launchCalendar';

export interface LaunchCalendarState {
  upcomingStyles: LaunchCalendarUpcomingStyles;
  upcomingStylesQuickViewData: UpcomingStylesQuickViewData;
  apiStatus: string;
}

const initialState = {
  upcomingStyles: {},
  upcomingStylesQuickViewData: {},
  apiStatus: ''
};

export default function launchCalendar(
  state: Readonly<LaunchCalendarState> = initialState,
  action: LaunchCalendarUpcomingProductsAction
): LaunchCalendarState {
  switch (action.type) {
    case SET_LAUNCH_CALENDAR_UPCOMING_STYLES:
      return { ...state, upcomingStyles: action.response };
    case ADD_UPCOMING_STYLES_QUICK_VIEW_DATA:
      return { ...state, upcomingStylesQuickViewData: { ...state.upcomingStylesQuickViewData, ...action.data } };
    case SET_API_STATUS:
      return { ...state, apiStatus: action.apiStatus };
    default:
      return state;
  }
}
